// @flow
import React, { Children, type Node } from 'react';
import classnames from 'classnames';

import { t } from 'Src/i18n';
import { ArrowButton } from 'Components/frameworks/arrow-button/ArrowButton.jsx';
import { SliderHandler } from 'Components/frameworks/slider-handler/SliderHandler.jsx';

export type ContentSlideShowProps = {
  children: Node,
  className?: string,
};

export function ContentSlideShow(props: ContentSlideShowProps) {
  const { children, className } = props;

  if (!Children.count(children)) return null;

  return (
    <SliderHandler hasKeyboardSupport hasLazyload hasSwipeSupport items={children}>
      {({
        hasControls,
        isNextControlDisabled,
        isPreviousControlDisabled,
        itemsNode,
        onNext,
        onPrevious,
      }) => (
        <div className={classnames(className, 'flex items-center justify-center')}>
          {hasControls && (
            <ArrowButton
              className={classnames('flex-none rtl:mr-4 shadow-sm', {
                invisible: isPreviousControlDisabled,
              })}
              isDisabled={isPreviousControlDisabled}
              label={t('common.previous')}
              onClick={onPrevious}
            />
          )}
          {itemsNode}
          {hasControls && (
            <ArrowButton
              className={classnames('flex-none rtl:ml-4 shadow-sm', {
                invisible: isNextControlDisabled,
              })}
              isDisabled={isNextControlDisabled}
              label={t('common.next')}
              onClick={onNext}
              rotation={180}
            />
          )}
        </div>
      )}
    </SliderHandler>
  );
}
